import { FullScreenLoadingSpinner, MainTitle } from 'ck-components';

import { CreateNewsForm } from '../../features/News';
import { TypedNavigate } from 'ck-utils';
import { useNews } from 'ck-queries';
import { useParams } from 'react-router-dom';

interface Props {
  isEdit?: boolean;
}

export function NewsCreatePage({ isEdit }: Props) {
  const { id } = useParams();
  const { data, isLoading } = useNews(isEdit);
  const prefill = isEdit ? data?.find((post) => post.id === id) : undefined;

  if (isEdit && !prefill && !isLoading) {
    // If there is no data for the given id, just go to the normal create form
    return <TypedNavigate to='/news/create' replace={true} />;
  }

  if (isEdit && isLoading) {
    return <FullScreenLoadingSpinner />;
  }

  return (
    <div className='flex w-full flex-col gap-6'>
      <MainTitle label={isEdit ? 'Uppdatera inlägg' : 'Skapa inlägg'} />
      <CreateNewsForm
        key={id ?? 'create'}
        isEdit={isEdit}
        newsId={id}
        prefill={prefill}
      />
    </div>
  );
}
